// extracted by mini-css-extract-plugin
module.exports = {"Select":"styles_Select__eX0U2"};